import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Auth from "./components/auth/Auth";
import PasswordReset from "./components/auth/PasswordReset";
import FacilityMasterHome from "./components/FacilityMasterHome";

// Protected Route
function PrivateRoute({ children }) {
  const token = sessionStorage.getItem("token");

  return token ? children : <Navigate to="/" />;
}

function App() {
  return (
    <Router>
      <Routes>

        {/* Login Page */}
        <Route path="/" element={<Auth />} />
        <Route
          path="/forgot-password"
          element={<PasswordReset mode="request" />}
        />
        <Route
          path="/reset-password"
          element={<PasswordReset mode="reset" />}
        />

        {/* Dashboard (Protected) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <FacilityMasterHome />
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;